import { BaseController } from '../../../common/base/controller';
import _ from 'lodash';

class NavbarController extends BaseController {
  constructor(
    controllerService,
    navbarService,
    faqService,
    $document,
    featureFlagService,
  ) {
    'ngInject';
    super({
      controllerService,
      navbarService,
      faqService,
      $document,
      featureFlagService,
    });
  }

  $onInit() {
    const { authService, navbarService, userService, config } = this;

    // Set authentication depending values
    this.isAuthenticated = authService.isAuthenticated();
    if (this.isAuthenticated) {
      // Set user
      this.user = userService.get();

      // Set navbar tabs
      this.navbarTabs = navbarService.getTabs();

      if (
        this.navbarTabs.inbox &&
        !this.isFeatureActive(
          this.FeatureNames.FF_INBOX_FOR_NEW_AND_DONE_DOCUMENTS,
        ) &&
        !this.isFeatureActive(
          this.FeatureNames.FF_INBOX_FOR_REJECTED_DOCUMENTS_WIHTOUT_IBAN,
        )
      ) {
        delete this.navbarTabs.inbox;
      }

      // Show user only for user role higher than guest
      this.showUser = !userService.hasRole(userService.Roles.Guest);
    }

    this.brandLogo = config.ui.navbar.brandLogo;
    this.isLogoLinked = this.config.ui.navbar.linkLogo;

    // UI specific status
    this.userDropdown = {
      isopen: false,
    };
  }

  isFeatureFlagActive(flag) {
    return this.featureFlagService.isFeatureActive(flag);
  }

  get showChristmasHat() {
    const today = new Date();
    return (
      today.getMonth() === 11 &&
      this.isFeatureFlagActive(this.FeatureNames.FF_EASTER_EGG_IN_HEADERBAR)
    );
  }

  logout() {
    const { authService, $state, $timeout } = this;

    // Unset user and tabs
    delete this.user;
    delete this.navbarTabs;

    $timeout(() => authService.logout()).then(() => {
      // Reload states after authentication change
      return $state.go('app.home', {}, { reload: true });
    });
  }

  get showFreshdeskFaqs() {
    return this.config.ui.freshdeskFaqs.length > 0;
  }

  dumpUser() {
    const { $log, envService, user } = this;
    const environment = envService.getEnvironment({ omit: ['tenants'] });

    $log.log(angular.toJson(user, true));
    $log.log(angular.toJson(environment, true));
  }

  openFaqModal() {
    this.faqService.openModal();
  }

  tabIsActive(tab) {
    if (tab.dropdown) {
      return _.some(tab.dropdown, (t) => this.tabIsActive(t));
    }
    const name = this.$state.$current.name;
    const product = this.$state.params.product;
    return name === tab.ref && product === (tab.params && tab.params.product);
  }

  getSref(tab) {
    if (tab.params) {
      return `${tab.ref}(${angular.toJson(tab.params)})`;
    }
    return tab.ref;
  }
}

export default NavbarController;
